import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    careersites: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_CAREERSITE_SELECT_IDS (store, ids) {
      store.careersites.selectIds = ids
    },
    REMOVE_CAREERSITE_SELECT_IDS (store, ids) {
      store.careersites.selectIds = store.careersites.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_CAREERSITE_SELECT_ID (store, id) {
      store.careersites.selectId = id
    },
    SET_CAREERSITE_FILTERS (store, filters) {
      store.careersites.filters = filters
    },
    SET_CAREERSITE_PAGINATE (store, val) {
      store.careersites.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getCareersites: (store, getters) => {
      return store.careersites.selectIds.map((id) => {
        return getters['entities/careersites/find'](id)
      })
    },
    getCareersitesFilters: (store, getters) => {
      return store.careersites.filters
    },
    getCareersitesPaginate: (store, getters) => {
      return store.careersites.paginate
    },
    getCareersite: (store, getters) => {
      return getters['entities/careersites/find'](store.careersites.selectId) || {}
    }
  },
  actions: {
    /*
    selectCareersites
    */
    selectCareersites ({commit, dispatch, getters, state}, filters) {
      return dispatch('getCareersites', filters)
      .then((response) => {
        commit('SET_CAREERSITE_FILTERS', filters)
        commit('SET_CAREERSITE_PAGINATE', response)
        commit('SET_CAREERSITE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectCareersites
    */
    refreshSelectCareersites ({commit, dispatch, getters, state}) {
      return dispatch('selectCareersites', getters.getCareersitesFilters)
    },
    /*
    selectCareersite
    */
    selectCareersite ({commit, dispatch, getters, state}, id) {
      return dispatch('getCareersiteById', id)
      .then((response) => {
        commit('SET_CAREERSITE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getCareersites
    */
    getCareersites ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/careersites`, {params: filters})
      .then((response) => {
        return dispatch('entities/careersites/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.careersites || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getCareersiteById
    */
    getCareersiteById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/careersites/${id}`)
      .then((response) => {
        return dispatch('entities/careersites/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.careersites[0]
      })
    },
    /*
    createCareersite
    */
    createCareersite ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/careersites`, data)
      .then((response) => {
        return dispatch('entities/careersites/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('setMenuCareersites')
        return response.careersites[0]
      })
    },
    /*
    updateCareersite
    */
    updateCareersite ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/careersites/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/careersites/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('setMenuCareersites')
        return response.careersites[0]
      })
    },
    /*
    deleteCareersite
    */
    deleteCareersite ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/careersites/${id}`)
      .then((response) => {
        commit('REMOVE_CAREERSITE_SELECT_IDS', [id])
        dispatch('entities/careersites/delete', id)
        dispatch('setMenuCareersites')
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Careersite.js